export const BUSINESS_START_DATE = "2020-01-01";
